import Vue from 'vue';
import vueHeadful from 'vue-headful';
import UUID from 'vue-uuid';
import moment from 'moment';
import './plugins/vuetify';
import App from './App.vue';
import router from './router';
import store from './store';
import './registerServiceWorker';
import 'roboto-fontface/css/roboto/roboto-fontface.css';
import 'material-design-icons-iconfont/dist/material-design-icons.css';
import './stylus/main.styl';

Vue.component('vue-headful', vueHeadful);

Vue.prototype.moment = moment;

Vue.config.productionTip = false;

// GLOBAL FILTERS
Vue.filter('price', (value) => {
  // convert from cents to dollars
  const dollarValue = value / 100;
  // display as USD
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  }).format(dollarValue);
});

new Vue({
  router,
  store,
  UUID,
  render: h => h(App),
}).$mount('#app');
